// import * as Sentry from "@sentry/react";
import queryString from "query-string";
import { getLocalIdentity, setLocalIdentity } from "@meitu/xdesign-identity";
import { getJumpQuery } from "@meitu/xdesign-widgets/dist/overseasAccessModal/jumpQuery";
import {
  clearTeamInfo,
  disableIdentityChangeListener,
  enableIdentityChangeListener,
  openIdentitySwitchPopupAfterLogin,
} from "@meitu/xdesign-widgets/dist/teamExports";
import { setLocalUid } from "@meitu/xdesign-widgets/dist/utils/uidKit";
import CODE from "@/constants/code";
import { fetchUserInfo } from "@/services/user";
import store from "@/store";
import { waitUntilGetGid } from "./gid";
import { getAppKey, getClientID, MODULE_ID, SCENE } from "@/constants";
import SaasSubscription, {
  EventNameEnum,
} from "@meitu/saas-subscription-popup";
import { getChannel, getMatrixChannel } from "@/utils";
import { getQueryParam } from "./query";

let processingLogin: (isLogin: string) => void = () => {};
// HACK 退登问题
let accessToken = "";
let actionType: "logout" | "login";
let vipModalCloseCallback: undefined | (() => void) = undefined;
let vipModalPayCallback: undefined | (() => void) = undefined;

export const updateLogoutAccessToken = (token: string) => {
  accessToken = token;
};

const getEnvValue = (env?: string) => {
  // 1 test, 0 线上（默认）, 2 beta
  let value;
  switch (env) {
    case "release":
      value = 0;
      break;
    case "beta":
      value = 2;
      break;
    default:
      value = 1;
  }

  return value;
};

export const getCallback = () => {
  const url = `${window.location.protocol}//${window.location.host}/callback.html?refresh=0`;
  return url;
};

/**
 * 初始化订阅弹窗组件
 */
const initVipModal = async (initVipModalOptions?: { [key: string]: any }) => {
  const params: any = queryString.parse(window.location.search);
  let env: any = process.env.NEXT_PUBLIC_ENV;
  if (process.env.NEXT_PUBLIC_ENV === "development") {
    env = "local";
  }

  const first_url = decodeURIComponent(
    params.first_url || window.sessionStorage.getItem("first_url") || "",
  );

  // 订阅团队id
  const localIdentity = getLocalIdentity();
  const jumpQuery = getJumpQuery();

  const instanceVipModal = new SaasSubscription({
    env,
    theme: "light",
    commonParams: {
      entrance: SCENE,
      module_id: SCENE,
      source: SCENE,
      app_key: getAppKey(),
      client_id: getClientID(),
      matrix_channel: getMatrixChannel(),
      callback_origin: window.location.origin,
      channel: getChannel(),
      first_ur: encodeURIComponent(first_url),
      subscribe_type: "meidou",
      ...jumpQuery,
      ...(localIdentity
        ? {
            oid: localIdentity?.oid || 0,
            groupId: localIdentity?.groupId || 0,
            purchase_scene: "normal",
          }
        : {}),
      ...initVipModalOptions,
    },
  });
  instanceVipModal
    .on(EventNameEnum.SUCCESS, async () => {
      // 更新接口
      await getUserInfo();
      vipModalPayCallback?.();
    })
    .on(EventNameEnum.LOGININVALID, () => {
      // 登录态失效
      handleLogout();
    })
    .on(EventNameEnum.CLOSE, () => {
      vipModalCloseCallback?.();
    });

  window.instanceVipModal = instanceVipModal;
};

export const initAccount = async () => {
  const gid = await waitUntilGetGid();
  const { MeituAccount } = await import("@meitu/account");
  window.account = MeituAccount({
    env: getEnvValue(process.env.NEXT_PUBLIC_ENV), // 指定环境 0 正式环境（默认）、1 Preview 测试环境、2、Beta 拟真测试环境
    gid, // 可选；自定义 gid
    clientId: getClientID(),
    theme: "mtxx",
    clientLanguage: "zh-Hans",
    overseas: 0,
    clientConfigs: {
      abroad: false,
      needPhone: false,
      enableWeChatOfficialAccount: true, // 开启关注公众号登录
    },
    syncDomains: true, // 可选；是否开启跨域名（非 *.meitu.com 域）同步登录和退出状态（HTTPS 域名才有效，目前只支持 Chrome 系浏览器，不支持 Safari 和火狐浏览器）
    onNeedLogin() {},
    onLogining() {},
    onLoginError() {},
    onLoginSuccess: async (result: any) => {
      actionType = "login";
      window.localStorage.setItem("access_token", result.accessToken);

      console.log("onLoginSuccess: result ======>", result);

      const status = await openIdentitySwitchPopupAfterLogin(
        result.uid,
        result.result,
      );
      if (!status) return;

      // 登录成功
      processingLogin(result.accessToken);

      setLocalUid(result.uid);
      getUserInfo();

      // 登录成功默认切换为个人身份
      setLocalIdentity(0, 0);
    },
    onLogoutError() {},
    onLogoutSuccess() {
      actionType = "logout";
    },
    syncDomainsOptions: {
      onComplete() {
        if (actionType === "logout") {
          window.location.reload();
        }
      },
    },
  });
};

const openAccount = async () => {
  //第三方帐号登录，退出后使用页面跳转涉及帐号内部状态同步，须确保帐号内部登录态清除
  await window.account.isLogin();
  const { openLoginPopup } = await import("@meitu/account-login-popup");
  const { ThirdPartyPlatform } = await import("@meitu/account-model");
  const { setClientTheme } = await import("@meitu/account-services");
  openLoginPopup({
    // ...登录弹窗配置选项，详见：LoginPopupProps
    title(text) {
      return (
        <div
          style={{
            color: "var(--content-primary, #0f1729)",
            textAlign: "center",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "32px",
          }}
        >
          {text}
        </div>
      );
    },
    autoDetectAndSetDarkTheme: false,
    theme: "v4",
    containerStyle: {
      minHeight: 473,
    },
    useLoginMethod: "",
    showMeituXiuXiuQRCode: false,
    thirdPartyAccounts: [
      ThirdPartyPlatform.Meitu,
      ThirdPartyPlatform.Weibo,
      ThirdPartyPlatform.WeChat,
      ThirdPartyPlatform.QQ,
    ],
    borderRadius: "14px",
    // 隐藏关闭按钮
    showCloseButton: true,
    closeable: true,
    switch: true, // 切换账号，会先清除登录状态
    leftSide() {
      return `<div style="width: 300px; height: 100%; min-height: 509px; border-radius: 14px 0 0 14px; background-image: url(https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/login/login.svg); background-size: cover; background-position: center center;"></div>`;
    },
    onClose() {
      // 关闭弹窗后的自定义处理，略...
    },
  });
};

// 未登录态时，打开登录弹窗
export const jumpToLogin = async () => {
  if (!window.account) {
    await initAccount();
  }

  // 打开登录弹窗
  await openAccount();

  // 等待登录结果
  return await new Promise((resolve) => (processingLogin = resolve));
};

export const handleLogout = async () => {
  // 清楚埋点中的uid
  window.mtstat?.logout();

  // 清空用户信息和美豆信息
  store.getActions().userModel.setUserInfo(undefined);
  store.getActions().userModel.setMeidouInfo(null);

  // 清除团队信息
  clearTeamInfo();
  // 移除身份切换监听
  disableIdentityChangeListener();

  const { STORAGE_KEY_LOGIN_BY_WEB } = await import("@meitu/account");
  window.sessionStorage.removeItem(STORAGE_KEY_LOGIN_BY_WEB);
  !window.account && (await initAccount());

  // HACK 退登问题
  let options = {};
  if (accessToken) {
    options = {
      headers: {
        "Access-Token": accessToken,
      },
    };
  }
  window.account?.logout({}, options);
};

// 打开VIP会员弹窗
export const openVipModal = async (
  params: { [key: string]: any } = {},
  closeCallback?: () => void,
  payCallback?: () => void,
  initVipModalOptions?: { [key: string]: any },
) => {
  vipModalCloseCallback = closeCallback;
  vipModalPayCallback = payCallback;

  if (!window.instanceVipModal) {
    await initVipModal(initVipModalOptions);
  }

  if (params?.oid) {
    // 如果场景透传了oid，则需要实时根据最新的oid去透传对应的app_key
    params.app_key = getAppKey(params.oid);
  }

  window.instanceVipModal?.open(params);
};

/**
 * 获取用户信息
 */
export const getUserInfo = async () => {
  const res = await fetchUserInfo();
  const data = res.data.data;
  if (res.data.code === CODE.OK && data) {
    window.localStorage.setItem("access_token", data.access_token);
    setLocalUid(data.userInfo.id);
    window.mtstat?.login(String(data.userInfo.id));
    updateLogoutAccessToken(data.access_token);

    store.getActions().userModel.setUserInfo({
      id: data.userInfo.id,
      screen_name: data.userInfo.screen_name,
      avatar: data.userInfo.avatar,
      is_vip: data.vipInfo.is_vip,
      vip_level: data.vipInfo.vip_level,
      vip_end_time: data.vipInfo.vip_end_time,
      vip_days: data.vipInfo.vip_days,
      available_amount: data.coinInfo.available_amount,
    });
    store.getActions().userModel.setMeidouInfo(data.coinInfo);
    store.getActions().userModel.setCutoutInfo(data.cutoutInfo);

    // 开启身份切换监听
    enableIdentityChangeListener();
  } else {
    store.getActions().userModel.setUserInfo(undefined);
    store.getActions().userModel.setMeidouInfo(null);
    store.getActions().userModel.setCutoutInfo(null);
  }

  store.getActions().userModel.setIsRequested(true);
};
